import React from 'react';
import {
  VisuallyHiddenText,
  StarFull,
  StarHalf100,
  StarEmpty100,
} from 'shared/legacy';

import stylesheet from './StarRatings.scss';
const starRatingStylingClass = 'star-rating';

const getStars = rating => {
  const TOTAL_NUMBER_OF_STARS = 5;
  const integerPart = Math.floor(rating);
  const fractionPart = rating - Math.floor(rating);

  const fullStars = Array.from({ length: integerPart }).map((_, index) => (
    <StarFull size="ty-c" className="full-star" key={`${index}-full`} />
  ));

  let halfStars = [];
  if (fractionPart >= 0.5) {
    halfStars = Array.from({ length: 1 }).map((_, index) => (
      <StarHalf100 size="ty-c" className="half-star" key={`${index}-half`} />
    ));
  }

  const numberOfEmptyStars =
    TOTAL_NUMBER_OF_STARS - fullStars.length - halfStars.length;
  const emptyStars = Array.from({
    length: numberOfEmptyStars,
  }).map((_, index) => (
    <StarEmpty100 size="ty-c" className="empty-star" key={`${index}-empty`} />
  ));

  return fullStars.concat(halfStars, emptyStars);
};

const StarRatings = ({ rating, label }) => {
  return (
    <div className={stylesheet[starRatingStylingClass]}>
      {getStars(rating)}
      <VisuallyHiddenText text={`review rating: ${rating} out of 5`} />
      {label && (
        <span className={stylesheet[`${starRatingStylingClass}__projects`]}>
          {label}
        </span>
      )}
    </div>
  );
};

export default StarRatings;
